import { render } from "./TemplatesForm.vue?vue&type=template&id=64579b40&scoped=true"
import script from "./TemplatesForm.vue?vue&type=script&lang=js"
export * from "./TemplatesForm.vue?vue&type=script&lang=js"

import "./TemplatesForm.vue?vue&type=style&index=0&id=64579b40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64579b40"]])

export default __exports__